module.exports = function(app) {

    app.controller('pages.forgotPassword.accountRecovery.step4', ["$state", "$scope", "userService", "coremetrics",
        function($state, $scope, userService, coremetrics) {

            var newPassword = "";
            var verifyPassword = "";
            var user = $state.params.user || "";

            // If step4 is called without the user token or the verification code, re-direct to step1.
            if (user === "" ||  !(user && user.userToken && user.userToken.length > 0) ||  !(user && user.verificationCode && user.verificationCode.length > 0)) {
                $scope.$parent.goto(1, false);
            }

            // Required for the 'newPassword' directive to setup bi-directional binding.
            $scope.showPasswordStrength = true;
            $scope.showRegularPassword = false;
            $scope.passwordRules = {
                minLength: 8,
                maxLength: 64
            };

            // Disable buttons until password rules service returns.
            $scope.disableButtons = true;
            $scope.showOkButton = false;
            $scope.footerMessage = {
                header: "",
                message: "",
                iconClass: "",
                show: false
            };

            $scope.newPasswordControls = function(controlsObject) {
                $scope.validate = function() {
                    return controlsObject.validate();
                };
            };

            var handleError = function(error) {
                var baseMessage = userService.parseBaseMessage(error);

                if (baseMessage && baseMessage.returnCode === 404) {
                    var context = (baseMessage.businessContext && baseMessage.businessContext.length > 0) ? baseMessage.businessContext : 'UNKNOWN_404';
                    $scope.$parent.goto(1, false, { error: { code: baseMessage.returnCode, context: context } });
                } else {
                    showGeneralErrorMessage();
                }
            };

            userService.getPasswordRules(user.userToken).then(
                function(response) {
                    if (response && response.data && response.data.payload && response.data.payload.authSecurityRule && response.data.payload.authSecurityRule.passwordLengthRule) {
                        $scope.passwordRules.minLength = response.data.payload.authSecurityRule.passwordLengthRule.minLength;
                        $scope.passwordRules.maxLength = response.data.payload.authSecurityRule.passwordLengthRule.maxLength;
                    }
                    // Password rules returned, enable buttons
                    $scope.disableButtons = false;
                },
                function(error) {
                    handleError(error);
                }
            );

            $scope.submit = function() {
                var isValid = $scope.validate();

                if (isValid && $scope.newPasswordForm.$valid) {
                    $scope.disableButtons = true;
                    $scope.footerMessage.show = false;
                    newPassword = $scope.newPasswordForm.newPassword.$viewValue;
                    verifyPassword = $scope.newPasswordForm.newPasswordVerify.$viewValue;

                    userService.submitNewPasswordAndUnlock(user.userToken, user.verificationCode, newPassword).then(
                        function(response) {
                            userService.showFooterMessage($scope.footerMessage, "", '<span data-aem-content="RECOVERY_STEP4_SUCCESS_MSG"></span>', false);
                            $scope.disableButtons = false;
                            $scope.showOkButton = true;

                            // Finish step 4 conversion event
                            coremetrics.finishConversion('STEP 4 PASSWORD UPDATE', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');
                        },
                        function(error) {
                            $scope.disableButtons = false;
                            handleError(error);
                        }
                    );
                }
            };

            $scope.okButton = function() {
                $scope.disableButtons = true;
                $scope.footerMessage.show = false;

                coremetrics.elementTag('FORGOT: OK STEP 4', 'FORGOT');
                // Finish whole flow conversion event
                coremetrics.finishConversion('FORGOT USERNAME OR PASSWORD', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');

                if ($scope.$parent.previousState && $scope.$parent.previousState.length > 0) {
                    // If user came from a defined previous state, take them back after successful account unlock.
                    $state.go($scope.$parent.previousState, $scope.$parent.previousStateParams);
                } else {
                    // Otherwise, after successful account unlock, take user to /home.
                    location.replace("/member/home");
                }
            };

            var showGeneralErrorMessage = function() {
                userService.showFooterMessage($scope.footerMessage, "", "We are having trouble processing your request right now. Try again in a few minutes. " +
                    "If the problem continues, please call the number on the back of your member ID card.", true);
            };

            // Start step 4 conversion event
            coremetrics.startConversion('STEP 4 PASSWORD UPDATE', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');
        }
    ]);
};